import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { RestaurantConfigService } from '../../services/restaurant-config.service';
import { resolveRestaurantLogoUrl } from '../../config/default-assets';
import { SectionScrollService } from '../../services/section-scroll.service';
import {NgOptimizedImage} from '@angular/common';

@Component({
  selector: 'app-footer',
  imports: [RouterLink, NgOptimizedImage],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  private readonly restaurantConfig = inject(RestaurantConfigService);
  private readonly sectionScroll = inject(SectionScrollService);

  readonly profile = this.restaurantConfig.profile;

  readonly logoSrc = computed(() => resolveRestaurantLogoUrl(this.profile()));

  readonly restaurantName = computed(() => this.profile()?.name ?? 'Kanyar Büfé');

  readonly tagline = computed(
    () =>
      // TODO: this.profile()?.descriptionFooter ??
      'Pákozd, a Velencei-tó partján — Gluténmentes konyha, házias pacalpörkölt, magyaros fogások és cseh csapolt sörök.'
  );

  readonly currentYear = new Date().getFullYear();

  readonly navLinks = computed(() => {
    const links: { label: string; anchor: string }[] = [
      { label: 'Rólunk', anchor: 'about' },
      { label: 'Étlap', anchor: 'menu' },
      { label: 'Galéria', anchor: 'gallery' },
    ];
    if (this.restaurantConfig.config().features.reservation) {
      links.push({ label: 'Asztalfoglalás', anchor: 'reservation' });
    }
    links.push({ label: 'Kapcsolat', anchor: 'contact' });
    return links;
  });

  readonly socials = [
    { name: 'Facebook', url: 'https://www.facebook.com/kanyarbufe', icon: 'fb' },
  ];

  scrollTo(anchor: string) {
    this.sectionScroll.navigateToLandingSection(anchor);
  }
}
